import { Configuration, PublicClientApplication, EndSessionRequest, AccountInfo, EventMessage, EventType } from "@azure/msal-browser";
import config from "./config";

const configuration: Configuration = {
  auth: {
    clientId: config.apiClientId,
    authority: config.authority,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    storeAuthStateInCookie: true,
  },
  system: {
    tokenRenewalOffsetSeconds: 600,
  },
};


export const authRequest = {
  scopes: config.graphScopes
};

export const createEndSessionRequest = (account?: AccountInfo) => {
  const esr: EndSessionRequest = {
    authority: config.authority,
    account,
  };
  return  esr;
};

export default new PublicClientApplication(configuration);